<template>
  <v-layout align-center justify-center fill-height>
    <v-progress-circular
      indeterminate
      color="blue">
    </v-progress-circular>
  </v-layout>
</template>

<script>
  import axios from 'axios';
  import AuthenticationService from '../../../services/AuthenticationService';

  export default {
    name: 'callback',
    mounted() {
      const hash = this.$route.hash.slice(1, this.$route.hash.length);
      const params = hash.split('&');
      const headers = ['access_token', 'token_type', 'expires_in'];
      const map = new Map();
      params.forEach((item) => {
        const split = item.split('=');
        headers.forEach((h) => {
          if (h === split[0]) {
            map.set(h, split[1]);
          }
        });
      });
      // esse localhost se refere a API do SignGo
      axios.get(`${process.env.SIGNGO_API}/users/me`,
        { headers: { Authorization: `Bearer ${map.get('access_token')}` } })
        .then((response) => {
          AuthenticationService
            .signin_with_signgo(response.data, map.get('access_token'))
            .then((resp) => {
              const token = resp.data.access_token;
              localStorage.setItem('access_token', token);
            })
            .catch((err) => {
              alert(err.response.data);  // eslint-disable-line
            })
            .finally(() => {
              window.close();
            })
          ;
        });
    },
  };
</script>



// WEBPACK FOOTER //
// src/views/authentication/signin/Callback.vue